module.exports = "/_next/static/images/img__feedbacks_left_top_desktop-a41272766ab61ada37b09bedbf32e7b3.png";